module.exports = __webpack_public_path__ + "static/other/gameColony.44be979b.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameColony.json
// module id = 2278
// module chunks = 0